import employeeapi from "../../../../services/employee";
import { toLocalDateKey } from "../../../../utils/date";

export const fetchQrAttendanceLogsApi = async (workDate) => {
  const dateParam = workDate || toLocalDateKey();
  const response = await employeeapi.get(`QrAttendanceLogs/by-branch/${dateParam}`);
  return response.data;
};

export const fetchQrTerminalsApi = async () => {
  const response = await employeeapi.get("QrTerminals/no-paginate");
  return response.data;
};

export const manualOpenAttendanceApi = async ({ employeeId, terminalId, checkInTime }) => {
  const response = await employeeapi.post("QrAttendanceLogs/manual-open", {
    employeeId,
    terminalId,
    checkInTime,
  });
  return response.data;
};

export const manualCompleteAttendanceApi = async ({ id, checkOutTime }) => {
  const response = await employeeapi.post("QrAttendanceLogs/manual-complete", {
    id,
    checkOutTime,
  });
  return response.data;
};

export const fetchIncompleteAttendanceLogsApi = async (branchId) => {
  const response = await employeeapi.get(`QrAttendanceLogs/incomplete-by-branch?branchId=${branchId}`);
  return response.data;
};
